<template>
<div v-if="team">
    <div v-if="actions">
        <confirmModal v-if="showDeleteConfirmModal" message="Vous êtes sûr de vouloir supprimer votre équipe ??" @confirm="deleteTeam" @closeMessage="showDeleteConfirmModal = false"></confirmModal>
        <confirmModal v-if="showPublishConfirmModal" message="Vous êtes sûr de vouloir publier votre équipe ? vous ne pourrez plus changer les numéros de joueurs" @confirm="publishTeam" @closeMessage="showPublishConfirmModal = false"></confirmModal>
        <confirmModal v-if="showFinishPurchasesConfirmModal" message="Vous êtes sûr de finir vos achats ? votre équipe sera prête pour le prochain match" @confirm="finishPurchases" @closeMessage="showFinishPurchasesConfirmModal = false"></confirmModal>
        <messageModal v-if="showDeleteMessage" message="votre équipe a été supprimée" @closeMessage="closeDeleteMessage"></messageModal>
        <messageModal v-if="showModalFinishPurchaseForbiden" message="Impossible de finir les achats, vous devez d'abord payer la star, ou la renvoyer. escroc." @closeMessage="showModalFinishPurchaseForbiden = false"></messageModal>
        <spinningModal v-if="showSpinner"></spinningModal>
        <spiralingExpenseModal v-if="showSpiralingExpenseModal" :spiralingExpenseResult="spiralingExpenseResult" @closeMessage="showSpiralingExpenseModal = false"></spiralingExpenseModal>
        <div v-if="team.status != 5  && (team.user.id == currentUser.id || currentUser.is_superuser)" class="row">
            <div class="large-3 columns" v-if="team.status == 3" >
                <router-link :to="{ name: 'TeamPurchases', params:{'id':team.id.toString()}}" >
                <button class="light-grey-button button-bar"><span><i class="fa fa-money" aria-hidden="true"></i>&nbsp;Achats</span></button>
                </router-link>
            </div>
            <div class="large-3 columns" v-if="team.status == 3" >
              <router-link :to="{ name: 'TeamRevoke', params:{'id':team.id}}" >
                <button class="light-grey-button button-bar"><span><i class="fa fa-trash-o" aria-hidden="true"></i>&nbsp;Renvois</span></button>
              </router-link>
            </div>
            <div class="large-3 columns" v-if="team.status == 3" >
                <button @click="finishPurchases" class="validation-btn button-bar">
                  <span><i class="fa fa-check" aria-hidden="true"></i>&nbsp;Terminer les achats</span>
                </button>
            </div>
            <div class="large-3 columns" v-if="team.status !== 3">
                <router-link :to="{ name: 'TeamEdit', params: { id: team.id.toString() }}" >
                <button class=" button-bar"><span><i class="fa fa-pencil" aria-hidden="true"></i>&nbsp;modifier</span></button>
                </router-link>
            </div>
            <div class="large-3 columns" v-if="team.status == 0 && team.base_upgrade_needed">
                <router-link :to="{ name: 'TeamBaseSkills', params: { id: team.id.toString() }}" >
                    <button class="button-bar"><span><i class="fa fa-gift" aria-hidden="true"></i>&nbsp;compétences de départ</span></button>
                </router-link>
            </div>
            <div class="large-3 columns" v-if="team.status == 0">
                <button @click="showPublishConfirmModal = true" class="button-bar"><span><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>&nbsp;&nbsp; publier</span></button>
            </div>
            <div class="large-3 columns" v-if="team.status == 1 && currentUser.is_superuser">
                <router-link :to="{ name: 'TeamCustomize', params: { id: team.id.toString() }}" >
                    <button class="button-bar"><span><i class="fa fa-cogs" aria-hidden="true"></i>&nbsp;&nbsp; Customizer</span></button>
                </router-link>
            </div>
            <div class="large-3 columns" v-if="team.status == 1">
                <button class="button-bar" @click="downloadTeamPdf(team.id)"><span><i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp; PDF</span></button>
            </div>
            <div class="large-4 columns" v-if="team.status == 2">
              <button @click="finishPlayerUpgrades" class="validation-btn button-bar">
                <span><i class="fa fa-check" aria-hidden="true"></i>&nbsp;Terminer les montées de niveau</span>
              </button>
            </div>
          <div class="large-3 columns end" v-if="team.status == 1">
                <button @click="showDeleteConfirmModal = true" class="alert button-bar"><span><i class="fa fa-trash-o" aria-hidden="true"></i>&nbsp;&nbsp; Supprimer</span></button>
            </div>
        </div>
    </div>
</div>
<div v-else>
    <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import spiralingExpenseModal from '../../common/spiraling-expense-modal.vue'
import confirmModal from '../../common/confirm-modal.vue'
import messageModal from '../../common/message-modal.vue'
import { mapGetters } from 'vuex'
import store from '../../../store/index.js'
import team from '../../../api/team.api'
import teamPurchases from '../../../api/team-purchases.api'
import spinningModal from '../../common/spinning-modal.vue'

export default {
  name: 'teamHeaderActions',
  components: {
    spinner,
    confirmModal,
    spiralingExpenseModal,
    messageModal,
    spinningModal
  },
  props: {
    'team': null,
    'actions': true
  },
  data () {
    return {
      showDeleteConfirmModal: false,
      showPublishConfirmModal: false,
      showFinishPurchasesConfirmModal: false,
      showDeleteMessage: false,
      showSpiralingExpenseModal: false,
      deletionStarted: false,
      showSpinner: false,
      showModalFinishPurchaseForbiden: false,
      spiralingExpenseResult: {'spiralling_roll': 2, 'lost_treasury': 110}
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ])
  },
  methods: {
    publishTeam () {
      if (this.team.status !== 0) {
        console.log('team status incomptabile, publish impossible')
        return
      }
      team.api.publishTeam(this.team.id)
      .then(response => {
        store.dispatch('purgeDetailedTeam', this.team.id.toString())
        store.dispatch('getDetailedTeam', this.team.id.toString())
        this.showPublishConfirmModal = false
      }, error => {
        console.log('impossible to publish team ' + this.team.id)
        console.log(error)
      })
    },
    finishPurchases () {
      // avant de publier les achats il faut vérifier si on a le droit de le faire
      this.showSpinner = true
      teamPurchases.api.canFinishPurchases(this.team.id)
        .then(response => {
          teamPurchases.api.finishTeamPurchases(this.team.id)
            .then(response => {
              this.showSpinner = false
              this.spiralingExpenseResult = response.body
              if (this.spiralingExpenseResult.spiralling_roll !== 0) {
                this.showSpiralingExpenseModal = true
              }
              this.showFinishPurchasesConfirmModal = false
              store.dispatch('reloadDetailedTeam')
            }, error => {
              console.log('impossible to finish team purchases ' + this.team.id)
              console.log(error)
            })
        }, error => {
          console.log(error)
          this.showSpinner = false
          this.showModalFinishPurchaseForbiden = true
        })
    },
    finishPlayerUpgrades () {
      let datas = {}
      datas.status = 3
      team.api.updateTeam(this.team.id, datas)
        .then(response => {
          this.$store.dispatch('reloadDetailedTeam')
        }, error => {
          console.log('erreur impossible to activate purchase mode')
          console.log(error)
        })
    },
    getRosterIcon () {
      return '/static/imgs/team-icons/' + this.team.ref_roster.name.replace(/\s+/, '') + '.png'
    },
    closeConfirmModal () {
      this.showConfirmModal = false
    },
    closeDeleteMessage () {
      this.showDeleteMessage = false
      this.$router.push({name: 'TeamList'})
    },
    deleteTeam () {
      this.showConfirmModal = false
      this.deletionStarted = true
      team.api.deleteTeam(this.team.id)
      .then(
        response => {
          this.showDeleteMessage = true
        },
        error => {
          console.log('Impossible to delete team ' + this.team.id)
          console.log(error)
        }
      )
    },
    downloadTeamPdf (id) {
      this.showSpinner = true
      team.api.downloadPDF(id)
        .then(
          response => {
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.team.name + '.pdf'
            link.click()
            this.showSpinner = false
          }, error => {
            console.log('impossible to download team pdf')
            console.log(error)
            this.showSpinner = false
          })
    }
  },
  created () {
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.button-bar {
    padding-left: 0;
    padding-right: 0;
    width: 100%
}
.validation-btn {
  background-color: #2cb293;
}

.validation-btn:hover{
  background-color: #30e3c2;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// team-header-actions.vue?24a8f703